export default {
  ORDERED: "ordered",
  ACTIVATED: "activated",
  EXPIRED: "expired",
  CANCELLED: "cancelled"
};
